import React, { useEffect, useRef } from "react";

interface PopupModalProps {
  isOpen: boolean
  children: React.ReactNode
  title?: string
  message?: string
  onCancel: (e: { preventDefault: () => void }) => void
  className?: string
  hideCloseButton?: boolean
}

export default function PopupModal({ isOpen, children, title = "", message = "", onCancel, className = "", hideCloseButton = false }: PopupModalProps) {
  const modalRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        onCancel({ preventDefault: () => { } });
      }
    };

    const handleClickOutside = (e: MouseEvent) => {
      if (modalRef.current && !modalRef.current.contains(e.target as Node)) {
        onCancel({ preventDefault: () => { } });
      }
    };

    if (isOpen) {
      document.addEventListener("keydown", handleKeyDown);
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, onCancel]);

  if (!isOpen) return null;

  const childrenArray = React.Children.toArray(children)

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
        <div className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
          <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
            {childrenArray}
          </div>
        </div>
      </div>
    </div>
  );
}
